export const formatDateWithTime = (str: string | Date) => {
    const monthArr = [
      "jan",
      "feb",
      "mar",
      "apr",
      "may",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
    ];
    const date = new Date(str);
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    let hours =
      date.getHours() === 0
        ? 12
        : date.getHours() >= 13
        ? date.getHours() - 12 < 10
          ? `0${date.getHours() - 12}`
          : date.getHours() - 12
        : date.getHours() < 10
        ? `0${date.getHours()}`
        : date.getHours();
    const minutes =
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    let amPm = date.getHours() >= 12 ? "pm" : "am";
    return `${day} ${monthArr[month]} ${year}, ${hours}:${minutes} ${amPm}`;
  };
  
  export const formatDateYYYYMMDD = (str: string | Date) => {
    if (str) {
      const date = new Date(str);
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      const month =
        date.getMonth() + 1 < 10
          ? `0${date.getMonth() + 1}`
          : date.getMonth() + 1;
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    } else {
      return "";
    }
  };
  
  export const formatDateDDMMYYYY = (str: string | Date) => {
    if (str) {
      const date = new Date(str);
  
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      const month =
        date.getMonth() + 1 < 10
          ? `0${date.getMonth() + 1}`
          : date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } else {
      return "";
    }
  };
  
  export const formatTimeHHMMSS = (totalMinutes: number) => {
    const totalSeconds = totalMinutes * 60;
  
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);
    const seconds = Math.floor(totalSeconds % 60); // Assuming seconds are zero as we only have total minutes
  
    // Pad with zeros to ensure two digits
    const paddedHours = String(hours).padStart(2, "0");
    const paddedMinutes = String(minutes).padStart(2, "0");
    const paddedSeconds = String(seconds).padStart(2, "0");
  
    // Return formatted time
    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  };
  